import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/footer/siteFooter/SiteFooterLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/TopNavigation/TopNavigationBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/visitor-setup/Analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/visitor-setup/DatadogLogsInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/visitor-setup/DatadogRumInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UtmCookieSetup"] */ "/app/apps/sb-shell/components/visitor-setup/UtmCookieSetup.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.29.7_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_reac_15c8be349baff2f6069e0a6cc60f58ff/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/packages/osano/src/OsanoConsentListener.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/runtime-configuration/src/PublicConfigurationContext.tsx");
